const Logo = ({ className = "h-12 w-12", size = "md" }) => {
  // Size presets for easier usage
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-12 w-12", 
    lg: "h-16 w-16",
    xl: "h-20 w-20"
  };

  const finalClassName = size && sizeClasses[size] ? sizeClasses[size] : className;

  return (
    <img 
      src="/mmm-icon.png"
      alt="MyMedMember"
      className={finalClassName}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default Logo;
